import { ReactElement } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Loader } from 'shared'
import { useAuth } from 'contexts/AuthContext'

type AuthGuardProps = {
  children: ReactElement;
};

function AuthGuard({ children }: AuthGuardProps) {
  const { token, isLoggedIn, loading } = useAuth()
  const location = useLocation()

  if (loading) return <Loader />

  if (!token || !isLoggedIn) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />
  }

  return children
}

export default AuthGuard
